var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('button',{staticClass:"button__continue",on:{"click":_vm.skip}},[_vm._v("Пропустить")])])}
var staticRenderFns = []

export { render, staticRenderFns }